<div *ngIf="patient" id="my-wrapper">
  <msd-my-sidebar (signOut)="signOut()"
                  [appointment]="appointment"
                  [patient]="patient"
                  [isWeightLoading]="isWeightLoading"
                  [size]="size"
                  [weight]="weight">
  </msd-my-sidebar>
  <div id="topbar-content-wrapper">
    <msd-my-topbar [patient]="patient"></msd-my-topbar>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
